angular.module('nv.components.tooltip-open').component('nvTooltipOpen', {
  template: require('./tooltip-open.html'),
  transclude: {
    externalBodyOpen: 'nvTooltipExternalBodyOpen',
    internalBodyOpen: 'nvTooltipInternalBodyOpen',
  },
  bindings: {
    title: '@',
    exam: '=',
  },
  controller: 'TooltipOpenCtrl',
});
